import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Loader from "components/Loader";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "./table-data";

// Redux and API
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/Reducers/GlobalReducer/globalSlice";
import { useSnackbarContext } from "components/SnackBarContext";
import { API_FAIL_MESSAGE, SUCCESS } from "constants/apiConstants";
import { API_ENDPOINTS } from "constants/apiConstants";
import DeleteIcon from "@mui/icons-material/Delete"; // Add this import at the top
import IconButton from "@mui/material/IconButton"; // Also import this

import api from "services/api";
import { BASE_IMAGE_URL } from "constants/apiConstants";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import PreviewDoc from "./PreviewDoc";
import { compressToUnder5MB } from "../property/utlis";

function Communities() {
  const [tableData, setTableData] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [open, setOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [isActive, setIsActive] = useState(true);

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    data: null,
  });

  const [commissionAmount, setCommissionAmount] = useState("");
  const [editingItem, setEditingItem] = useState(null);
  const auth = useSelector((state) => state.auth);
  const [imageFile, setImageFile] = useState(null);
  const [communityImageUrl, setCommunityImageUrl] = useState("");
  // console.log("communityImageUrl", communityImageUrl);
  const [documentImageUrl, setDocumentImageUrl] = useState([]);
  // console.log("documentImageUrl", documentImageUrl);
  const [bannerFile, setBannerFile] = useState(null);
  const [bannerImageUrl, setBannerImageUrl] = useState("");
  const [sectionFile, setSectionFile] = useState(null);
  const [sectionImageUrl, setSectionImageUrl] = useState("");

  const { IsLoginData } = auth;
  const tableName = "Community";
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();
  const [documentTypes, setDocumentTypes] = useState([]);

  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTableData();
    getAllDocumentType();
  }, []);

  const handleAddDocument = () => {
    setDocuments((prev) => [
      ...prev,
      { documentTypeId: "", subTitle: "", filePath: null },
    ]);
  };
  const handleDocumentChange = (index, field, value) => {
    setDocuments((prev) =>
      prev.map((doc, i) => (i === index ? { ...doc, [field]: value } : doc))
    );
  };
  const getTableData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_COMMUNITIES);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setTableData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const getAllDocumentType = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_ALL_DOC_TYPES);
      // console.log(`GET `, response);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setDocumentTypes(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleAddNew = () => {
    setEditingItem(null);
    setNewTitle("");
    setNewDescription("");
    setIsActive(true);
    setImageFile(null); // Clear any previous file
    setCommunityImageUrl("");
    setOpen(true);
    setDocuments([]);
    setBannerFile(null);
    setBannerImageUrl("");
    setSectionFile(null);
    setSectionImageUrl("");
    setCommissionAmount("");
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setNewTitle(item.communityname || "");
    setNewDescription(item.description || "");
    setIsActive(!!item.isactive);
    setImageFile(item.image_path); // Clear any previous file
    setCommunityImageUrl(item.image_path);
    setOpen(true);
    setDocuments(item?.documents || []);
    setBannerFile(item.banner_image_path || null);
    setBannerImageUrl(item.banner_image_path || "");
    setSectionFile(item.section_image_path || null);
    setSectionImageUrl(item.section_image_path || "");
    setCommissionAmount(item.commission_amount_info || "");
  };

  const handleClose = () => {
    setOpen(false);
    setNewTitle("");
    setNewDescription("");
    setIsActive(true);
    setEditingItem(null);
    setBannerFile(null);
    setBannerImageUrl("");
    setSectionFile(null);
    setSectionImageUrl("");
  };

  const handleSubmit = async () => {
    const payload = {
      user_id: IsLoginData.idUser,
      communityname: newTitle,
      description: newDescription,
      isactive: isActive ? 1 : 0,
      image_path: communityImageUrl,
      // documents: documents
      documents: editingItem
        ? documents.map((doc) => ({
            ...doc,
            community_id: editingItem.community_id,
          }))
        : documents,
      banner_image_path: bannerImageUrl,
      section_image_path: sectionImageUrl,
      commission_amount_info: commissionAmount,
    };

    console.log("edit", payload);

    try {
      dispatch(setLoading(true));

      let response;
      if (editingItem) {
        payload.community_id = editingItem.community_id;

        response = await api.post(API_ENDPOINTS.UPDATE_COMMUNITY, payload);
      } else {
        response = await api.post(API_ENDPOINTS.CREATE_COMMUNITY, payload);
      }
      // console.log("response", response);
      const { status, message } = response.data;
      dispatch(setLoading(false));

      if (status === SUCCESS) {
        showSuccessSnackbar(
          message ||
            (editingItem
              ? `Updated ${tableName} successfully`
              : `Created ${tableName} successfully`)
        );
        handleClose();
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Submit ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };
  const UploadImage = async (file, type = "property", index = 0) => {
    dispatch(setLoading(true));
    setIsLoading(true);
    // const formData = new FormData();
    // formData.append("file", file);

    const safeFile = await compressToUnder5MB(file);

    const formData = new FormData();
    formData.append("file", safeFile);

    try {
      const response = await api.post(API_ENDPOINTS.IMAGE_UPLOAD, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const uploadedUrl = response.data.data;
      // console.log("uploadedUrl", response);
      setIsLoading(false);
      // if (type === "community") {
      //   setCommunityImageUrl(uploadedUrl);
      // }
      // if (type === "document") {
      //   setDocumentImageUrl((prev) => [...prev, uploadedUrl]);
      //   handleDocumentChange(index, "filePath", uploadedUrl);
      // }
      if (type === "community") {
        setCommunityImageUrl(uploadedUrl);
      }
      if (type === "banner") {
        setBannerImageUrl(uploadedUrl);
      }
      if (type === "section") {
        setSectionImageUrl(uploadedUrl);
      }
      if (type === "document") {
        setDocumentImageUrl((prev) => [...prev, uploadedUrl]);
        handleDocumentChange(index, "filePath", uploadedUrl);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Upload error:", error);
    } finally {
      setIsLoading(false);
      dispatch(setLoading(false));
    }
  };

  const UploadPdfOnly = async (file, type = "property", index = 0) => {
    dispatch(setLoading(true));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await api.post(API_ENDPOINTS.UPLOAD_PDF, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const uploadedUrl = response.data.data;
      // console.log("uploadedUrl", response);
      setIsLoading(false);
      if (type === "community") {
        setCommunityImageUrl(uploadedUrl);
      }
      if (type === "document") {
        setDocumentImageUrl((prev) => [...prev, uploadedUrl]);
        handleDocumentChange(index, "filePath", uploadedUrl);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleDelete = (item) => {
    setConfirmDialog({ open: true, data: item });
  };
  const { columns, rows } = authorsTableData(
    tableData,
    handleEdit,
    handleDelete
  );

  const performDelete = async (item) => {
    console.log("DELETE_COMMUNITY", item);
    try {
      dispatch(setLoading(true));
      const response = await api.delete(
        `${API_ENDPOINTS.DELETE_COMMUNITY}/${item.id}`
      );
      const { status, message } = response.data;
      dispatch(setLoading(false));
      // console.log("Delete Response::", response);
      if (status === SUCCESS) {
        showSuccessSnackbar(message || "Community deleted successfully");
        getTableData();
        setConfirmDialog({ open: false, data: null });
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Delete ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleRemoveDocument = async (indexToRemove, doc) => {
    //deleteCommunity/8'
    const result = await api.delete(
      `${API_ENDPOINTS.DELETE_COMMUNITY_DOCUMENT}/${doc.id}/${doc.communityId}`
    );
    if (result.data.status === SUCCESS) {
      setDocuments((prev) => prev.filter((_, i) => i !== indexToRemove));
      setDocumentImageUrl((prev) => prev.filter((_, i) => i !== indexToRemove));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {tableName}
                </MDTypography>
                <Button
                  variant="contained"
                  color="white"
                  startIcon={<Icon>add</Icon>}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  // showTotalEntries={false}
                  // noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>
          {editingItem ? `Edit ${tableName}` : `Add New ${tableName}`}
        </DialogTitle>
        <DialogContent dividers>
          <Loader loading={isLoading} />
          <TextField
            fullWidth
            label="Title"
            margin="normal"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
          <TextField
            fullWidth
            label="Description (Learn more about this community)"
            margin="normal"
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
          />
          <TextField
            fullWidth
            label="Commission Info"
            margin="normal"
            value={commissionAmount}
            onChange={(e) => setCommissionAmount(e.target.value)}
          />
          <MDBox mt={2}>
            <InputLabel>Community Logo</InputLabel>
            <input
              accept="image/*"
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  file.preview = URL.createObjectURL(file); // store preview URL
                  setImageFile(file);
                  UploadImage(file, "community");
                }
              }}
              style={{ marginTop: "8px" }}
            />

            {(imageFile || editingItem?.image_path) && (
              <Box display="flex" alignItems="center" mt={2} gap={1}>
                <img
                  src={
                    imageFile?.preview ||
                    (editingItem?.image_path?.startsWith("http")
                      ? editingItem.image_path
                      : `${BASE_IMAGE_URL}${editingItem?.image_path}`)
                  }
                  alt="Community Preview"
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
                <IconButton
                  color="error"
                  onClick={() => {
                    setImageFile(null);
                    setCommunityImageUrl("");
                    setEditingItem((prev) =>
                      prev ? { ...prev, image_path: null } : null
                    );
                  }}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </MDBox>

          <MDBox mt={2}>
            <InputLabel>Banner Image</InputLabel>
            <input
              accept="image/*"
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  file.preview = URL.createObjectURL(file);
                  setBannerFile(file);
                  UploadImage(file, "banner");
                }
              }}
              style={{ marginTop: "8px" }}
            />

            {(bannerFile || editingItem?.banner_image_path) && (
              <Box display="flex" alignItems="center" mt={2} gap={1}>
                <img
                  src={
                    bannerFile?.preview ||
                    (editingItem?.banner_image_path?.startsWith("http")
                      ? editingItem.banner_image_path
                      : `${BASE_IMAGE_URL}${
                          editingItem?.banner_image_path || ""
                        }`)
                  }
                  alt="Banner Preview"
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
                <IconButton
                  color="error"
                  onClick={() => {
                    setBannerFile(null);
                    setBannerImageUrl("");
                    setEditingItem((prev) =>
                      prev ? { ...prev, banner_image_path: null } : null
                    );
                  }}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </MDBox>

          <MDBox mt={2}>
            <InputLabel>Section Image</InputLabel>
            <input
              accept="image/*"
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  file.preview = URL.createObjectURL(file);
                  setSectionFile(file);
                  UploadImage(file, "section");
                }
              }}
              style={{ marginTop: "8px" }}
            />

            {(sectionFile || editingItem?.section_image_path) && (
              <Box display="flex" alignItems="center" mt={2} gap={1}>
                <img
                  src={
                    sectionFile?.preview ||
                    (editingItem?.section_image_path?.startsWith("http")
                      ? editingItem.section_image_path
                      : `${BASE_IMAGE_URL}${
                          editingItem?.section_image_path || ""
                        }`)
                  }
                  alt="Section Preview"
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
                <IconButton
                  color="error"
                  onClick={() => {
                    setSectionFile(null);
                    setSectionImageUrl("");
                    setEditingItem((prev) =>
                      prev ? { ...prev, section_image_path: null } : null
                    );
                  }}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </MDBox>

          <FormControlLabel
            control={
              <Switch
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
            }
            label="Active"
          />
          <Box mt={3}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <InputLabel>Add New Document</InputLabel>
              <IconButton color="primary" onClick={handleAddDocument}>
                <AddIcon />
              </IconButton>
            </Box>

            {documents.map((doc, index) => (
              <Box
                key={index}
                display="flex"
                gap={1}
                alignItems="center"
                mt={2}
                sx={{ overflowX: "auto" }} // optional: scroll if overflow
              >
                <Select
                  size="small"
                  value={doc.documentTypeId}
                  onChange={(e) =>
                    handleDocumentChange(
                      index,
                      "documentTypeId",
                      e.target.value
                    )
                  }
                  displayEmpty
                  sx={{ flexBasis: "25%", minWidth: 120, height: 40 }}
                >
                  <MenuItem value="" disabled>
                    Select Type
                  </MenuItem>
                  {documentTypes.map((item) => (
                    <MenuItem key={item} value={item.documentTypeId}>
                      {item.documentTypeName}
                    </MenuItem>
                  ))}
                </Select>

                <TextField
                  size="small"
                  placeholder="Document Title"
                  value={doc.subTitle}
                  sx={{ flexBasis: "25%", minWidth: 120, height: 40 }}
                  onChange={(e) =>
                    handleDocumentChange(index, "subTitle", e.target.value)
                  }
                />

                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file?.type === "application/pdf") {
                      handleDocumentChange(index, "filePath", file);
                      UploadPdfOnly(file, "document", index);
                    } else {
                      alert("Only PDF files are allowed");
                    }
                  }}
                />
                {doc.filePath ? (
                  <Button
                    onClick={() => {
                      setSelectedDoc(doc);
                      setOpenPreviewModal(true);
                    }}
                  >
                    Preview
                  </Button>
                ) : (
                  <Button disabled title="Upload a document to preview">
                    Preview
                  </Button>
                )}
                <IconButton
                  aria-label="remove-document"
                  color="error"
                  onClick={() => handleRemoveDocument(index, doc)}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            style={{ color: "#fff" }}
            variant="contained"
            onClick={handleSubmit}
          >
            {editingItem ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <PreviewDoc
        openPreviewModal={openPreviewModal}
        setOpenPreviewModal={setOpenPreviewModal}
        selectedDoc={selectedDoc}
      />
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, data: null })}
        aria-labelledby="delete-confirm-title"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "1rem",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle
          id="delete-confirm-title"
          sx={{ fontWeight: "bold", textAlign: "center" }}
        >
          Delete Community
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "1rem",
            fontSize: "1rem",
            color: "text.secondary",
          }}
        >
          Are you sure you want to delete this Community?
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "1rem" }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              performDelete(confirmDialog.data);
            }}
          >
            Yes, Delete
          </Button>
          <Button
            variant="contained"
            color="inherit"
            onClick={() => setConfirmDialog({ open: false, data: null })}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Communities;
